import { useEffect, useState } from "react";
import { BosDurum, Buton, Iskelet, Rozet, SatirDugmesi, SatirMetni } from "@koclukpanel/ui";
import { ApiHatasi } from "./api";
import { siparislerim } from "./api-magaza";
import { hataMetni } from "./hata-metni";
import { SIPARIS_DURUMU_ETIKETI, type Siparis } from "./magaza-tipleri";
import { SiparisDetay, gunBicimi, siparisRozetTonu } from "./SiparisDetay";

/**
 * SİPARİŞLERİM — F-GAM-17, oyunlaştırma dalga 2 / sürüm 7a.
 *
 * Liste ve durum SUNUCUDAN; ekran yalnız en yeni siparişi üste alır (sunucu sırasına güvenmek yerine, tek satırlık
 * sunum kararı). Adres bilgisi bu listede de, ayrıntıda da yoktur.
 */
export interface SiparislerimProps {
  /** Boş durumda "Mağazaya git" düğmesi; verilmezse düğme çizilmez. */
  onMagaza?: () => void;
}

export function Siparislerim({ onMagaza }: SiparislerimProps = {}) {
  const [liste, setListe] = useState<Siparis[] | null>(null);
  const [kapali, setKapali] = useState(false);
  const [hata, setHata] = useState<string | null>(null);
  const [yenile, setYenile] = useState(0);
  const [secili, setSecili] = useState<Siparis | null>(null);

  useEffect(() => {
    let iptal = false;
    void (async () => {
      try {
        const l = await siparislerim();
        if (!iptal) {
          setHata(null);
          setListe(l);
        }
      } catch (e) {
        if (iptal) return;
        if (e instanceof ApiHatasi && e.durum === 404) setKapali(true);
        else setHata(hataMetni(e, "Siparişlerin alınamadı."));
      }
    })();
    return () => {
      iptal = true;
    };
  }, [yenile]);

  if (kapali) return <p className="text-notr-600 text-sm">Mağaza şu an kapalı.</p>;
  if (hata) {
    return (
      <div className="flex flex-col items-start gap-2">
        <p role="alert" className="rounded-alan bg-hata-50 text-hata-700 w-full px-3 py-2 text-sm">
          {hata}
        </p>
        <Buton
          gorunum="ikincil"
          onClick={() => {
            setHata(null);
            setListe(null);
            setYenile((n) => n + 1);
          }}
        >
          Tekrar dene
        </Buton>
      </div>
    );
  }
  if (liste === null) return <Iskelet satir={4} />;

  if (secili) {
    return (
      <SiparisDetay
        key={secili.id}
        siparis={secili}
        onGeri={() => setSecili(null)}
        // Detayda adres verildi ya da iptal edildi: listeye dönünce eski durum görünmesin.
        onDegisti={(y) => setListe((l) => l?.map((x) => (x.id === y.id ? y : x)) ?? l)}
      />
    );
  }

  if (liste.length === 0) {
    return (
      <BosDurum
        baslik="Henüz siparişin yok"
        aciklama="Mağazadan bir ürün seçince siparişin burada görünür."
        eylem={onMagaza && <Buton onClick={onMagaza}>Mağazaya git</Buton>}
      />
    );
  }

  const yeniden = [...liste].sort((a, b) => b.tarih.localeCompare(a.tarih));

  return (
    <div className="flex flex-col gap-3">
      <h3 className="sr-only">Siparişlerim</h3>
      <ul className="flex flex-col gap-2">
        {yeniden.map((s) => (
          <li key={s.id}>
            <SatirDugmesi onClick={() => setSecili(s)}>
              <SatirMetni baslik={s.urunAdi} altBaslik={`${s.puan} puan · ${gunBicimi(s.tarih)}`} />
              <Rozet ton={siparisRozetTonu(s.durum)} className="shrink-0">
                {SIPARIS_DURUMU_ETIKETI[s.durum]}
              </Rozet>
            </SatirDugmesi>
          </li>
        ))}
      </ul>
    </div>
  );
}
